<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button
            variant="white"
            class="btn-icon rounded-circle mr-50 text-primary bg-white"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span> Editar usuario
      </h2>
    </div>
    <b-card>
      <!-- form -->
      <validation-observer ref="editUser">
        <b-form
          class="mt-2"
          @submit.prevent="handleSubmit"
          @keydown.enter="handleSubmit"
        >
          <!-- Sección Imagen/Avatar -->
          <h4 class="mb-2 mt-1">Imagen de perfil</h4>
          <b-row>
            <b-col cols="12" class="mb-2 auth-create-form d-flex justify-content-center">
              <ImageDropzone v-if="userPrepare" ref="images" :files="files" />
            </b-col>
          </b-row>
          <hr />
          <!-- Sección Datos de acceso -->
          <h4 class="mb-2 mt-2">Datos de acceso</h4>
          <b-row>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Usuario"
                  :rules="{required, usernameUnique:id}"
              >
                <b-form-group
                    :label="'Usuario'"
                    label-for="account-e-username"
                >
                  <b-form-input
                      v-model="user.username"
                      name="username"
                      :placeholder="'Usuario'"
                  />
                  <small class="form-text text-muted">
                    Este campo servirá para iniciar sesión. Debe ser único por usuario
                  </small>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6" class="d-flex align-items-center">
              <b-form-checkbox
                v-model="user.active"
                :value="1"
                class="d-inline-block mb-2 mt-1"
                switch
                inline
              >
                Estado usuario <span v-if="user.active == 1"> (Activado) </span><span v-else> (Desactivado) </span>
              </b-form-checkbox>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <b-form-checkbox
                  v-model="changePassword"
                  value="true"
                  plain
                >
                  <strong>¿Desea cambiar la contraseña?</strong>
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                v-if="changePassword"
                label-for="account-password"
              >
                <b-form-input
                  v-model="password"
                  name="password"
                  :placeholder="Contraseña"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <!-- Sección Información personal -->
          <h4 class="mb-2 mt-2">Información personal</h4>
          <b-row>
            <b-col sm="6">
              <b-form-group
                :label="'Nombre'"
                label-for="account-name"
              >
                <b-form-input
                  v-model="user.name"
                  name="name"
                  :placeholder="'Nombre'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                :label="'Apellidos'"
                label-for="account-username"
              >
                <b-form-input
                  v-model="user.surname"
                  :placeholder="'Apellidos'"
                  name="surname"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                :label="'DNI'"
                label-for="account-dni"
              >
                <b-form-input
                  v-model="user.dni"
                  name="dni"
                  :placeholder="'DNI'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                :label="'Puesto de trabajo'"
                label-for="account-job"
              >
                <b-form-input
                  v-model="user.job"
                  name="job"
                  :placeholder="'Puesto de trabajo'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <validation-provider
                #default="{ errors }"
                :name="'Rol'"
                rules="required"
              >
                <b-form-group
                  :label="'Rol'"
                  label-for="account-rols"
                >
                  <v-select
                    v-model="role"
                    label="display_name"
                    :filterable="false"
                    :searchable="false"
                    :options="filteredRoles"
                    placeholder="Selecciona un rol"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <hr />
          <!-- Sección Departamentos -->
          <h4 class="mb-2 mt-2">Departamentos</h4>
          <b-row>
            <b-col sm="12">
              <b-form-group
                label="Selecciona el departamento que pertenece el usuario"
                label-for="account-departments"
              >
                <b-row>
                  <b-col
                    v-for="item in filteredDepartments"
                    :key="item.id"
                    sm="3"
                  >
                    <b-form-checkbox
                      v-model="departments"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <!-- Sección Notificaciones -->
          <h4 class="mb-2 mt-2">Notificaciones</h4>
          <b-row>
            <b-col sm="12">
              <b-form-checkbox
                  v-if="role && role.name === 'super_admin'"
                  v-model="user.notifications"
                  :value="true"
                  class="d-inline-block mb-2 mt-1"
              >
                Recibir notificaciones del sistema
              </b-form-checkbox>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Email"
                  :rules="{email, emailUnique:id}"
              >
                <b-form-group
                    :label="'Email'"
                    label-for="account-e-mail"
                >
                  <b-form-input
                      v-model="user.email"
                      name="email"
                      :placeholder="'Email'"
                  />
                  <small class="form-text text-muted">
                    Introduce un correo para recibir notificaciones por email.
                  </small>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <b-form-group
                  :label="'Telefono'"
                  label-for="account-phone"
              >
                <b-form-input
                    v-model="user.phone"
                    name="phone"
                    :placeholder="'+34666666666'"
                />
                <small class="form-text text-muted">
                  Introduce un teléfono para recibir notificaciones por SMS. Recuerda añadir el prefijo.
                </small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" >
              <h4 class="mb-2 mt-2">Laboral</h4>
            </b-col>
            <b-col v-if="canEditModuleVacaciones" sm="6" >
              <b-form-group
                  :label="'Calendario'"
                  label-for="user-calendar"
              >
                <BaseSelect
                    v-model="calendar"
                    :searchable="true"
                    :clearable="true"
                    :multiple="false"
                    :httpBody="{
                      client_id: currentClient.id,
                      is_active: true,
                    }"
                    :resource="'/calendars'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <small class="form-text mb-1 d-block">
                Selecciona <strong>Agrupación de horarios</strong> (turnos rotativos) <strong>o</strong> <strong>Horario</strong> (horario fijo), no ambos. Si no se asigna ninguno, se aplicará el horario por defecto de la empresa.
              </small>
            </b-col>
            <b-col sm="6">
              <b-form-group
                  :label="'Agrupación de horarios'"
                  label-for="user-schedule-group"
              >
                <BaseSelect
                    v-model="scheduleGroup"
                    :searchable="true"
                    :clearable="true"
                    :multiple="false"
                    :readonly="!!schedule"
                    :httpBody="{
                      client_id: currentClient.id,
                    }"
                    :resource="'/work-schedule-groups'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                  :label="'Horario'"
                  label-for="user-schedule"
              >
                <BaseSelect
                    v-model="schedule"
                    :searchable="true"
                    :clearable="true"
                    :multiple="false"
                    :readonly="!!scheduleGroup"
                    :httpBody="{
                      client_id: currentClient.id,
                      is_active: true,
                    }"
                    :resource="'/work-schedules'"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Sección Vacaciones -->
          <div v-if="canModuleVacation && currentUser && (currentUser.roles[0].name === 'super_admin' || currentUser.roles[0].name === 'admin')">
            <h4 class="mb-2 mt-2">Vacaciones</h4>
            <b-row>
              <b-col sm="6">
                <validation-provider
                    #default="{ errors }"
                    name="Número de días anuales de vacaciones"
                    :rules="{required, min_value:0}"
                >
                  <b-form-group
                      :label="'Número de días anuales de vacaciones'"
                      label-for="account-annual_vacation_days"
                  >
                    <b-form-input
                        v-model="user.annual_vacation_days"
                        name="annual_vacation_days"
                        :placeholder="'Número de días anuales de vacaciones'"
                    />
                    <small class="form-text text-muted">
                      Introduce el número de días anuales de vacaciones que tendrá este usuario.
                    </small>
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
          </div>
          <div class="text-right">
            <b-button
              type="submit"
              variant="primary"
              class="mt-2 mr-1"
            >
              {{ 'Guardar' }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  BFormCheckbox, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import ImageDropzone from '@/components/elements/ImageDropzone/ImageDropzone.vue'
import vSelect from 'vue-select'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ImageDropzone,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormCheckbox,
    BaseSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id: this.$route.params.id,
      calendar: '',
      schedule: '',
      scheduleGroup: '',
      role: {},
      companies: '',
      departments: [],
      files: [],
      profileFile: null,
      required,
      email,
      userPrepare: false,
      changePassword: false,
      password: '',
      canModuleVacation: localStorage.getItem('canModuleVacation') === 'true',
    }
  },
  watch: {
    scheduleGroup(val) {
      if (val) this.schedule = ''
    },
    schedule(val) {
      if (val) this.scheduleGroup = ''
    },
  },
  computed: {
    ...mapGetters({
      selectRoles: 'users/getRoles',
      user: 'users/getUser',
      selectCompanies: 'companies/getListCompanies',
      departmentsSelect: 'departments/getSelectDepartments',
      currentClient: 'clients/getCurrentClient',
      currentUser: 'auth/getUser',
      canEditModuleVacaciones: 'clients/getCanEditModuleVacations',
    }),
    filteredDepartments() {
      return this.departmentsSelect.filter(dep => dep.active)
    },
    filteredRoles() {
      if (this.currentUser && this.currentUser.roles && this.currentUser.roles[0].name === 'admin') {
        return this.selectRoles.filter(role => role.name !== 'super_admin')
      }
      return this.selectRoles
    },
  },
  methods: {
    ...mapActions({
      edit: 'users/edit',
      getUser: 'users/getUser',
      selectDepartments: 'departments/selectDepartments',
      getRoles: 'users/getRoles',
    }),
    ...mapMutations({
      setSelectDepartments: 'departments/setSelectDepartments',
    }),
    setData() {
      if (this.user.avatar !== undefined && this.user.avatar !== null && this.user.avatar) {
        const avatar = {
          name: 'Avatar',
          url: this.user.avatar,
          urlDelete: `/users/delete_image/${this.user.id}`,
        }
        this.files = [avatar]
      }
      if (this.user.roles) {
        this.role = this.user.roles[0]
      }
      if (this.user.calendar) {
        this.calendar = this.user.calendar
      }
      if (this.user.work_schedule) {
        this.schedule = this.user.work_schedule
      }
      if (this.user.work_schedule_group) {
        this.scheduleGroup = this.user.work_schedule_group
      }
      this.userPrepare = true
    },
    setClients() {
      if (this.user.clients) {
        this.clients = this.user.clients
      }
    },
    setDepartments() {
      if (this.user.departments[0]) {
        this.user.departments.forEach(element => {
          this.departments.push(element.id)
        })
      }
    },
    handleSubmit() {
      this.$refs.editUser.validate().then(success => {
        if (success) {
          const { id } = this.user
          const formData = this.createFormData()
          if (formData) {
            this.edit({ id, user: formData })
          }
        }
      })
    },
    createFormData() {
      const data = this.$refs.images.getFormData()
      if (this.departments.length > 0) {
        this.departments.forEach(element => {
          if (element && element !== null) {
            data.append('departments[]', element)
          }
        })
      } else {
        data.append('departments', '')
      }
      if (this.role) {
        data.append('role', this.role.name)
        if (this.role.name !== 'super_admin') {
          data.append('notifications', false)
        } else {
          data.append('notifications', this.user.notifications)
        }
      }
      data.append('name', this.user.name)
      data.append('surname', this.user.surname)
      data.append('job', this.user.job)
      data.append('email', this.user.email)
      data.append('phone', this.user.phone)
      data.append('dni', this.user.dni)
      data.append('active', this.user.active)
      data.append('username', this.user.username)
      data.append('annual_vacation_days', this.user.annual_vacation_days)
      data.append('client_id', this.currentClient.id)
      data.append('calendar_id', this.calendar ? this.calendar.id : null)
      data.append('work_schedule_id', this.schedule ? this.schedule.id : null)
      data.append('work_schedule_group_id', this.scheduleGroup ? this.scheduleGroup.id : null)

      if (this.changePassword === 'true') {
        data.append('password', this.password)
      }

      return data
    },
  },
  async created() {
    await this.getUser(this.$route.params.id)
    await this.setData()
    await this.selectDepartments({client_id: this.currentClient.id, page: 1, per_page: 1000, search: ''})
    await this.setDepartments()
    await this.getRoles()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
